import {createReducer, on} from '@ngrx/store';
import * as ordersActions from './order-list-actions';
import * as orderDetailsActions from '../order-details/order-details-actions';
import * as fromOrders from './order-list-state';
import {OrderPagedResponse} from '@app/marketplace/orders/_models/order.interface';
import {state} from '@angular/animations';

const initialState: fromOrders.State = {isLoading: false, data: {count: 0, totalCount: 0} as OrderPagedResponse};
export const reducer = createReducer(
  initialState,
  on(ordersActions.LoadingOrdersAction, (state) => {
    return {...state, isLoading: true};
  }),
  on(ordersActions.ListOrdersAction, (state, {data}) => {
    return {...state, isLoading: false, data};
  }),
  on(orderDetailsActions.LoadingOrderDetailsAction, (state, {orderCode}) => {
    state.data.data.map(x => {
      if (x.orderCode == orderCode) {
        if (x.orderDetails) {
          x.orderDetails.isLoading = true;
        } else {
          x.orderDetails = { details: null, isLoading: true};
        }
      }
      return x;
    });
    return {...state};
  }),
  on(orderDetailsActions.GetOrderDetailsAction, (state, {data, orderCode}) => {
    state.data.data.map(x => {
      if (x.orderCode == orderCode) {
        x.orderDetails.details = data;
        x.orderDetails.isLoading = false;
      }
      return x;
    });
    return {...state};
  }),
  on(orderDetailsActions.CancelOrderDetailsRequestAction, (state, {orderCode}) => {
    state.data.data.map(x => {
      if (x.orderCode == orderCode) {
        x.orderDetails.isLoading = false;
      }
      return x;
    });
    return {...state};
  }),
  on(ordersActions.CancelOrderRequestAction, (state) => {
    return {...state, isLoading: false};
  }),
);
